import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog } from '@headlessui/react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white/80 backdrop-blur-md fixed w-full z-50 border-b border-primary-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link 
              to="/" 
              className="font-display text-3xl text-primary-800 hover:text-primary-600 transition-colors"
            >
              AsterIsland
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-primary-600 hover:text-primary-800 transition-colors font-medium"
            >
              Home
            </Link>
            <a 
              href="https://portfolio.asterisland.com/" 
              className="text-primary-600 hover:text-primary-800 transition-colors font-medium"
            >
              Dragonsworn Portfolio
            </a>
            <a 
              href="https://coyoteas.com/" 
              className="text-primary-600 hover:text-primary-800 transition-colors font-medium"
            >
              Coy O'Teas
            </a>
            <a 
              href="https://saltwood.asterisland.com/" 
              className="text-primary-600 hover:text-primary-800 transition-colors font-medium"
            >
              Saltwood Tea & Coffee
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(true)}
              className="text-primary-600 hover:text-primary-800 transition-colors"
              aria-label="Open menu"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="fixed inset-0 z-50 md:hidden"
      >
        <Dialog.Overlay className="fixed inset-0 bg-black/20 backdrop-blur-sm" />
        <motion.div
          initial={{ x: '100%' }}
          animate={{ x: 0 }}
          exit={{ x: '100%' }}
          className="fixed right-0 top-0 h-full w-full max-w-xs bg-white shadow-xl"
        >
          <div className="flex flex-col p-6">
            <div className="flex justify-end">
              <button
                onClick={() => setIsOpen(false)}
                className="text-primary-600 hover:text-primary-800 transition-colors"
                aria-label="Close menu"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="mt-8 flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-primary-600 hover:text-primary-800 transition-colors font-medium text-lg"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <a 
                href="https://portfolio.asterisland.com/" 
                className="text-primary-600 hover:text-primary-800 transition-colors font-medium text-lg"
              >
                Dragonsworn Portfolio
              </a>
              <a 
                href="https://coyoteas.com/" 
                className="text-primary-600 hover:text-primary-800 transition-colors font-medium text-lg"
              >
                Coy O'Teas
              </a>
              <a 
                href="https://saltwood.asterisland.com/" 
                className="text-primary-600 hover:text-primary-800 transition-colors font-medium text-lg"
              >
                Saltwood Tea & Coffee
              </a>
            </div>
          </div>
        </motion.div>
      </Dialog>
    </nav>
  );
};

export default Navbar;